import { mapActions } from "vuex";
import VueCircle from 'vue2-circle-progress'
import { GET_USER_SUBSCRIPTION, GET_USER_TRANSACTIONS } from '@/store/actions.type'


export default {
	data () {
		return {
			fill: { gradient: ["#658dbd"] },
			subscriptionLoading: true,
			transactionLoading: true,
			subscriptiondata: true
		}
	},

	components: {
		VueCircle
	},

	computed: {
		subscription () {
			return this.$store.state.home.subscription;
		},

		transactions () {
			return this.$store.state.home.transactions;
		},

		userData () {
			return this.$store.state.authentication.user;
		}
	},

	created () {
		this.fetchusersubscription();
	},

	methods: {
		...mapActions({
			getusersubscription: GET_USER_SUBSCRIPTION,
			getusertransactions: GET_USER_TRANSACTIONS
		}),

		async fetchusersubscription () {
			this.subscriptionLoading = false;
			await this.getusersubscription().then(data => {
				if (data == null) {
					this.subscriptiondata = false
				}
			});
			this.subscriptionLoading = true;
		},

		async fetchusertransactions () {
			var self = this;

			this.transactionLoading = false;
			await this.getusertransactions().then(data => {

			});
			this.transactionLoading = true;
		},
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/account.js